// extracted by mini-css-extract-plugin
module.exports = {"image":"Feature_image__2hCnI","lead":"Feature_lead__2y3kj"};